import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import translationEN from '../locales/en/translation.json'
import translationFR from '../locales/fr/translation.json'
import translationES from '../locales/es/translation.json'
import translationCZ from '../locales/cz/translation.json'
import translationDE from '../locales/de/translation.json'
import translationZH from '../locales/zh/translation.json'
import translationHI from '../locales/hi/translation.json'
import translationIT from '../locales/it/translation.json'

export const SUPPORTED_LANGUAGES = ['en', 'fr', 'es', 'cz', 'de', 'zh', 'hi', 'it']

export const normalizeLanguage = (value) => {
  if (!value) return 'en'
  if (SUPPORTED_LANGUAGES.includes(value)) return value
  const base = value.split(/[-_]/)[0]
  if (SUPPORTED_LANGUAGES.includes(base)) return base
  return 'en'
}

const getInitialLanguage = () => {
  if (typeof window === 'undefined') return 'en'
  const stored = window.localStorage.getItem('i18nextLng')
  return normalizeLanguage(stored)
}

const resources = {
  en: { translation: translationEN },
  fr: { translation: translationFR },
  es: { translation: translationES },
  cz: { translation: translationCZ },
  de: { translation: translationDE },
  zh: { translation: translationZH },
  hi: { translation: translationHI },
  it: { translation: translationIT },
}

if (!i18n.isInitialized) {
  i18n.use(initReactI18next).init({
    resources,
    lng: getInitialLanguage(),
    fallbackLng: 'en',
    supportedLngs: SUPPORTED_LANGUAGES,
    nonExplicitSupportedLngs: true,
    cleanCode: true,
    load: 'languageOnly',
    interpolation: {
      escapeValue: false,
    },
  })
}

export default i18n
